customElements.define(
  'atc-notification-popup',
  class AtcNotificationPopup extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth > 768) return;

      const {
        productMessage: [productMessage],
      } = codeGetTargets(this);

      this.unsubscribeCartUpdate = subscribe('cartUpdate', (cart) =>
        setTimeout(async () => {
          productMessage.innerText =
            cart.direction == 1 ? productMessage.dataset.added : productMessage.dataset.removed;
          if (this.hasAttribute('data-active')) return;
          this.toggleAttribute('data-active', true);

          setTimeout(() => {
            this.toggleAttribute('data-active', false);
          }, 3000);
        }, 250),
      );
    }

    disconnectedCallback() {
      if (this.unsubscribeCartUpdate) {
        this.unsubscribeCartUpdate();

      }
    }
  },
);
